import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

const headerLineLoadingConfig = style => [
  {
    main: setLoadingConfigObject('square', 1, null, style),
  },
];

export { headerLineLoadingConfig };
